export const RegionTypeMapper = {
  Coastal: 'Coastal',
  'Rural/Regional': 'Rural/Regional',
  'Rural/Remote': 'Rural/Remote',
  Indigenous: 'Indigenous',
  SEQ: 'South East Queensland',
  Resources: 'Resources',
};

export const LabelMapper = {
  upgradeInformation: 'Upgrade information',
  damSafety: 'Dam safety',
  storage: 'Storage',
  construction: 'Construction',
  currentVolume: 'current volume (ML)',
  capacity: 'capacity (ML)',
  fullSupplyLevel: 'full supply level (m)',
  catchmentArea: 'catchment area',
  yearsOld: 'age',
  dateOfLastUpgrade: 'Date of last upgrade',
  upgradeTargetDate: 'Upgrade target date',
  acceptableFloodCapacity: 'Acceptable flood capacity (%)',
  populationAtRisk: 'Population at risk',
  consequenceCategory: 'Consequence category',
  failureImpactRating: 'Failure impact rating',
  emergencyActionPlan: 'Emergency action plan',
  localDisasterManagementGroup: 'Local disaster management group',
  districtDisasterManagementGroup: 'District disaster management group',
  dateOfLastAudit: 'Date of last audit',
  reducedFullSupply: 'Reduced full supply (ML)',
  damType: 'Dam type',
  material: 'Material',
  embankmentMaxHeight: 'Embankment maximum height (m)',
  spillwayType: 'Spillway type',
  spillwayNoOfGates: 'Spillway number of gates',
};



// WEBPACK FOOTER //
// ./src/helpers/label-mapper.js